import { img } from '@phi/components';
import { SettingsEntry } from '../settings-entry';
import icon from '../../../../../frontend/phi3d/src/assets/img/SVG_icons/Bottom/visualisation/display_triangles.svg';
import { h } from 'vue';
import { FormNumber } from '@components/form';
import triangles, { triangles_with_spinner } from '@frontend/state/triangles';

export const DisplayTrianglesIcon = icon;

export function DisplayTriangles() {
    return SettingsEntry(
        'Display triangles',

        'Number of triangles per face for the display. Range: 200—20000.',

        img(icon),

        h(FormNumber, {
            id: 'triangles-input',
            value: triangles(),
            'onUpdate:value': x => triangles_with_spinner(x),
            change: true,
            min: 200,
            max: 20000,
        }),
    );
}
